Alerts = require 'views/lib/alerts'
Auth = require 'db/auth'
_ = require 'underscore'

showFileSizeError = (board) ->
  memberHasLargeAttachments = Auth.me().isFeatureEnabled('largeAttachments')

  org = board.getOrganization()
  orgHasLargeAttachments = org? && org.isFeatureEnabled('largeAttachments')

  message = if memberHasLargeAttachments || orgHasLargeAttachments
    'file size exceeds 250mb'
  else
    'file size exceeds 10mb'

  Alerts.show(message, 'error', 'upload', 5000)


module.exports = (board, files) ->
  if !_.isArray(files)
    files = [files]

  for file in files
    if !Auth.me().canUploadAttachment(file)
      showFileSizeError(board)
      return true

  return false



// WEBPACK FOOTER //
// ./app/scripts/views/internal/warn-if-file-too-large.coffee